// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Gallery_wrapper__SPqUA","inner":"Gallery_inner__dytp8","single":"Gallery_single__p4JRg","headline":"Gallery_headline__8MSmG"};